__turbopack_context__.v({
  "className": "space_grotesk_e4da2166-module__25hPGa__className",
});
